import React from "react";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";

import { SettingsPage } from "../pages/settings/SettingsPage";
import AccountSettingsPage from "../pages/accountSettings/AccountSettingsPage";
import { ScheduledReportsPage } from "../pages/scheduledReports/ScheduledReportsPage";
import BlockPageContentPage from "../pages/blockPageContent/BlockPageContentPage";
import { DomainLookupPage } from "../pages/domainLookup/DomainLookupPage";
import { isScheduleReportAvailable } from "../store/config.selectors";

export const SettingsRouter = () => {
  const showScheduledReports = useSelector(isScheduleReportAvailable);

  return (
    <Routes>
      <Route path="/*" element={<SettingsPage />} />

      <Route path="account" element={<AccountSettingsPage />} />

      {showScheduledReports && (
        <Route path="scheduled-reports" element={<ScheduledReportsPage />} />
      )}

      <Route path="blocked-pages/*" element={<BlockPageContentPage />} />

      <Route path="domain-lookup" element={<DomainLookupPage />} />
    </Routes>
  );
};
